export default __webpack_public_path__ + "static/media/bg_light_grey.f0f94834.svg";